var r=r=>r.currentTarget.contains(r.target)&&(!r.relatedTarget||!r.currentTarget.contains(r.relatedTarget)),t=r=>!r.currentTarget.contains(r.relatedTarget);export{t as a,r as g};
